<template>
  <div id="app">
    <pos-auth v-if="isAuthenticated"></pos-auth>
    <modal-login></modal-login>
    <modal-register></modal-register>
    <modal-password></modal-password>
    <lines v-if="isAuthenticated"></lines>
    <router-view></router-view>
  </div>
</template>

<script>
import Login from '@/components/modals/Login.vue'
import Register from '@/components/modals/Register.vue'
import ResetPassword from '@/components/modals/PasswordReset.vue'
import PosAuth from './components/setup/posAuth'
import {mapGetters, mapActions} from 'vuex'
import {EventBus} from '@/assets/js/event-bus.js'
import helpers from '@/mixins/helpers.js'
import Lines from '@/components/menus/lines'

export default {
  name: 'app',
  components: {
    Lines,
    PosAuth,
    'modal-login': Login,
    'modal-register': Register,
    'modal-password': ResetPassword
  },
  data () {
    return {
      globalToastType: '',
      lastWidth: null
    }
  },
  created () {
    this.$store.commit('OPTIONS_SET_TOAST', '')
    this.getGlobalCategories()
    window.addEventListener('keyup', function (e) {
      if (e.which === 27) {
        EventBus.$emit('escKey')
      }
    })
    this.$nextTick(() => {
      window.addEventListener('resize', this.checkSizeBreakpoint)
    })
    this.checkLines()
  },
  mounted () {
    this.addMeta()
    var sessionExpired = window.localStorage.removeItem('SESSION_EXPIRED')
    if (sessionExpired) {
      EventBus.$emit('toggleLoginModal')
      this.$toasted.error('Ihr Session ist abgelaufen', {
        theme: 'primary',
        position: 'top-right',
        duration: 10000,
        action: {
          text: 'X',
          class: 'toastBtn',
          onClick: (e, toastObject) => {
            toastObject.goAway(0)
          }
        },
        icon: 'fingerprint'
      })
    }
    var passwordStart = this.$route.query.resetpassword
    if (passwordStart) {
      EventBus.$emit('togglePasswordResetModal')
    }
  },
  mixins: [helpers],
  methods: {
    ...mapActions([
      'getLines',
      'getGlobalCategories'
    ]),
    checkLines () {
      if (this.isAuthenticated) {
        var self = this
        this.getLines({
          cb: () => {
            for (var i in self.lines) {
              if (self.lines[i].is_vendor_in_channel) {
                self.$store.commit('USER_CALL_WAS_WAITING', self.lines[i].uid)
              }
            }
          }
        })
      }
    },
    checkSizeBreakpoint () {
      if (this.lastWidth) {
        var currentWidth = window.innerWidth
        var breakPoints = [712, 1300]
        for (var i in breakPoints) {
          if ((currentWidth < breakPoints[i] && this.lastWidth >= breakPoints[i]) || (currentWidth > breakPoints[i] && this.lastWidth <= breakPoints[i])) {
            EventBus.$emit('sizeBreakPoint', currentWidth)
            break
          }
        }
        this.lastWidth = currentWidth
      } else {
        this.lastWidth = window.innerWidth
      }
    },
    addMeta () {
      var meta = document.createElement('meta')
      meta.httpEquiv = 'X-Version'
      meta.content = this.$store.getters.options_get_version
      document.getElementsByTagName('head')[0].appendChild(meta)
    },
    resolveGlobalToast (type) {
      this.globalToastType = type
      var toastOpts = this.$store.getters.options_toast(type)
      this.$toasted.clear()
      this.$toasted[toastOpts.color](toastOpts.message, {
        theme: 'primary',
        position: 'top-right',
        duration: 10000,
        action: {
          text: 'X',
          class: 'toastBtn',
          onClick: (e, toastObject) => {
            toastObject.goAway(0)
          }
        },
        icon: toastOpts.icon
      })
      this.$store.commit('OPTIONS_SET_TOAST', '')
      this.globalToastType = ''
    }
  },
  computed: {
    ...mapGetters({
      lines: 'user_get_lines',
      isAuthenticated: 'auth_is_authenticated',
      globalToastOptions: 'options_global_toast'
    })
  },
  watch: {
    globalToastOptions: function (type) {
      if (type && this.globalToastType !== type) {
        this.resolveGlobalToast(type)
      }
    },
    isAuthenticated: function (value) {
      this.checkLines()
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/App.vue